import React, { useState } from "react";
import searchIcon from "../../../assets/header/search-icon.svg";
import { ReactComponent as MagnifyingGlassSvg } from "../../../assets/icons/magnifying-glass-grey.svg";

const SearchBox = ({ placeholder, onChange }) => {
  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleKeyUp = (e) => {
    if (e.key.toLowerCase() !== "enter") return;
    onChange && onChange(searchValue);
  };

  return (
    <div className="search-box">
      <MagnifyingGlassSvg className="search-box__icon" />
      <input
        className="search-box__input"
        type="text"
        placeholder={placeholder ?? "Search"}
        value={searchValue}
        onChange={handleSearchChange}
        onKeyUp={handleKeyUp}
      />
    </div>
  );
};

export default SearchBox;
